import Storages  from 'js-storage'

const APP_KEY   = process.env.VUE_APP_NAME
const TOKEN_KEY = APP_KEY + '_access_token'
const REFRESH_TOKEN_KEY = APP_KEY + '_refresh_token'

// Anciennes clés possibles (si APP_KEY était undefined)
const OLD_TOKEN_KEY = 'undefined_access_token'
const OLD_REFRESH_TOKEN_KEY = 'undefined_refresh_token'
/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
    getToken() {
        if( !Storages.localStorage.get(TOKEN_KEY) ){
            // Migration pour le token principal
            const oldToken = Storages.localStorage.get(OLD_TOKEN_KEY)
            if (oldToken && !Storages.localStorage.get(TOKEN_KEY)) {
                Storages.localStorage.set(TOKEN_KEY, oldToken)
                Storages.localStorage.remove(OLD_TOKEN_KEY)
            }

            // Migration pour le refresh token
            const oldRefreshToken = Storages.localStorage.get(OLD_REFRESH_TOKEN_KEY)
            if (oldRefreshToken && !Storages.localStorage.get(REFRESH_TOKEN_KEY)) {
                Storages.localStorage.set(REFRESH_TOKEN_KEY, oldRefreshToken)
                Storages.localStorage.remove(OLD_REFRESH_TOKEN_KEY)
            }
        }
        return Storages.localStorage.get(TOKEN_KEY)
    },

    saveToken(accessToken) {
        Storages.localStorage.set(TOKEN_KEY, accessToken)
    },

    removeToken() {
        Storages.localStorage.remove(TOKEN_KEY)
    },

    getRefreshToken() {
        return Storages.localStorage.get(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        Storages.localStorage.set(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        Storages.localStorage.remove(REFRESH_TOKEN_KEY)
    }

}

export { TokenService }